var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$route.params.kravicka_id
      ? _c(
          "aside",
          {
            staticClass: "sideMenu position-fixed h-100",
            class: { open: _vm.showSideMenu }
          },
          [
            _c("router-link", { attrs: { to: "/" } }, [
              _c("img", {
                staticClass: "img-fluid header__logo",
                attrs: {
                  src: "assets/img/adoptuj-kravicku-logo.svg",
                  alt: "adoptuj-kravicku-logo"
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "sideMenu__close d-none d-xl-block",
                attrs: {
                  to: {
                    name: "kravicka",
                    params: { kravicka_id: _vm.$route.params.kravicka_id }
                  },
                  id: "backToCow"
                }
              },
              [_c("span", { staticClass: "icon" })]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "sideMenu__close d-xl-none",
                attrs: { id: "backToDressingRoom" },
                on: {
                  click: function($event) {
                    _vm.showSideMenu = false
                  }
                }
              },
              [_c("span", { staticClass: "icon" })]
            ),
            _vm._v(" "),
            _c("ul", { staticClass: "m-sideMenu" }, [
              _c("li", { staticClass: "a-sideMenu__item" }, [
                _c(
                  "a",
                  {
                    class: { active: _vm.activeCategory === "bezpecnost" },
                    on: {
                      click: function($event) {
                        return _vm.$emit(
                          "showProducts",
                          "bezpecnost",
                          "Bezpečnosť"
                        )
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "icon --bezpecnost" }),
                    _vm._v("Bezpečnosť\n                ")
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "a-sideMenu__item" }, [
                _c(
                  "a",
                  {
                    class: { active: _vm.activeCategory === "vianoce" },
                    on: {
                      click: function($event) {
                        return _vm.$emit("showProducts", "vianoce", "Vianoce")
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "icon --vianoce" }),
                    _vm._v("Vianoce\n                ")
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "a-sideMenu__item" }, [
                _c(
                  "a",
                  {
                    class: { active: _vm.activeCategory === "oblecenie" },
                    on: {
                      click: function($event) {
                        return _vm.$emit(
                          "showProducts",
                          "oblecenie",
                          "Oblečenie"
                        )
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "icon --oblecenie" }),
                    _vm._v("Oblečenie\n                ")
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "a-sideMenu__item" }, [
                _c(
                  "a",
                  {
                    class: { active: _vm.activeCategory === "obuv" },
                    on: {
                      click: function($event) {
                        return _vm.$emit("showProducts", "obuv", "Obuv")
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "icon --obuv" }),
                    _vm._v("Obuv\n                ")
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "a-sideMenu__item" }, [
                _c(
                  "a",
                  {
                    class: { active: _vm.activeCategory === "ciapky" },
                    on: {
                      click: function($event) {
                        return _vm.$emit("showProducts", "ciapky", "Čiapky")
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "icon --ciapky" }),
                    _vm._v("Čiapky\n                ")
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "a-sideMenu__item" }, [
                _c(
                  "a",
                  {
                    class: { active: _vm.activeCategory === "doplnky" },
                    on: {
                      click: function($event) {
                        return _vm.$emit("showProducts", "doplnky", "Doplnky")
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "icon --doplnky" }),
                    _vm._v("Doplnky\n                ")
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "a-sideMenu__item --textLink" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: "kravicka",
                          params: { kravicka_id: _vm.$route.params.kravicka_id }
                        }
                      }
                    },
                    [
                      _vm._v("\n                    Zavrieť šatník"),
                      _c("span", { staticClass: "icon --zavriet" })
                    ]
                  )
                ],
                1
              )
            ])
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn --primary d-xl-none",
        attrs: { id: "openShopMenu" },
        on: {
          click: function($event) {
            _vm.showSideMenu = true
          }
        }
      },
      [_c("span", { staticClass: "icon" })]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }